// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"ee5f5c63","181":"9cfa6d03","453":"433979fe","468":"3e34e9e0"}[chunkId] + ".chunk.js";
};